import React, { useState } from "react";
import OutboundSharpIcon from "@mui/icons-material/OutboundSharp";
import { ArrowCircleRight } from "@mui/icons-material";
const CapitalTabs = () => {
  const [activeTab, setActiveTab] = useState(1);

  const tabs = [
    {
      id: 1,
      title: "For Brands",
      description:
        "Brands get empowered to faster execution of their retail branding campaigns. Lets see how?",
      points: [
        "Get 360 degree birds eye view of your campaign in real time",
        "State of art matchmaking AI driven algorithm finds the best rated vendors, hyperlocally. Your risk is completely covered.",
        "Standardised production protocols and SOP’s in place leading to optimum quality.",
      ],
      buttonText: "Get Started",
    },
    {
      id: 2,
      title: "For Vendors",
      description:
        "Vendor Partners can focus on things that they are best at i.e Manufacturing goods. They don't have to worry about closing business.",
      points: [
        "Get trained on the best practices of the manufacturing industry.",
        "We deliver confirmed work orders to you.No half cooked leads.",
        "Complete utilisation of idle capacity.",
      ],
      buttonText: "Download App",
    },
    {
      id: 3,
      title: "For IPs",
      description:
        "With Pixell, you can earn more, take control of your schedule, and steer your path to success.",
      points: [
        "Earn more with competitive pay structures.",
        "You become your own boss. Work at your own convenience and time.",
        "24X7 assistance for issue resolution and smooth payments.",
      ],
      buttonText: "Download App",
    },
  ];

  const handleMouseEnter = (id) => {
    setActiveTab(id);
  };

  const handleMouseLeave = () => {
    setActiveTab(null);
  };

  return (
    <section className=" bg-white m-16 md:m-32">
      {/* Upper Section */}
      <div className="text-center mb-12">
        <p className="text-sm uppercase tracking-wide text-gray-500 mb-2">
          Benefits
        </p>
        <h2 className="text-xl md:text-4xl font-bold text-gray-900">
          Maximizing Value For All Users
        </h2>
      </div>

      <div className="flex flex-col lg:flex-row items-center justify-center space-y-6 lg:space-y-0 lg:space-x-6">
        {tabs.map((tab) => (
          <div
            key={tab.id}
            onMouseEnter={() => handleMouseEnter(tab.id)}
            onMouseLeave={handleMouseLeave}
            className={`relative transition-all duration-300 ease-in-out flex flex-col justify-between ${
              activeTab === tab.id
                ? "text-white w-[320px] md:w-[600px] lg:w-[400px] bg-cover bg-center"
                : "bg-gray-200 text-black w-[280px] md:w-[520px] lg:w-[320px]"
            } p-6 rounded-lg shadow-lg hover:cursor-pointer`}
            style={{
              backgroundImage:
                activeTab === tab.id
                  ? `url('/assests/images/LandingPage/bg-Img11.webp')` // Replace with your image path
                  : "none",
              minHeight: "30rem", // Ensures consistent height for all tabs
            }}
          >
            {/* Icon Section */}

            {activeTab === tab.id ? (
              <ArrowCircleRight fontSize="large" />
            ) : (
              <OutboundSharpIcon fontSize="large" />
            )}

            {/* Tab Content */}
            <div>
              <h3 className="text-xl font-semibold mb-4">{tab.title}</h3>
              <p
                className={`text-sm mb-4 ${
                  activeTab === tab.id ? "text-white" : "text-black"
                }`}
              >
                {tab.description}
              </p>

              {tab.points && (
                <ul className="space-y-2 mb-6">
                  {tab.points.map((point, index) => (
                    <li key={index} className="flex items-center space-x-2">
                      <span className="text-green-400 font-bold">✔</span>
                      <span className="text-sm">{point}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {/* Call-to-Action Button */}
            {/* <button
        className={`py-2 px-4 rounded-full border-2 ${
          activeTab === tab.id
            ? "border-blue-500 bg-blue-500 text-white hover:bg-blue-600"
            : "border-blue-500 bg-transparent text-blue-500 hover:bg-blue-100"
        }`}
      >
        {tab.buttonText}
      </button> */}
          </div>
        ))}
      </div>
    </section>
  );
};

export default CapitalTabs;
